<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{ translations('navbar.return_management') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-return'>{{ translations('return.archive_return') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('return.return_detail') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('return.arrival_date') }}</th>
                <td v-if="!Number(returnInfo.closing_flag)">
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.arrived_at) || '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return.arrival_date') }}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_arrived' class='form-control input-date'>
                      <input type='time' v-model='time_arrived' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('arrived_at',`${date_arrived} ${time_arrived}`,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{$invoiceTools.formatDateHours(returnInfo.arrived_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return.return_date') }}</th>
                <td v-if="!Number(returnInfo.closing_flag)">
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.returned_at) || '----------'}}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return.return_date') }}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_returned' class='form-control input-date'>
                      <input type='time' v-model='time_returned' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('returned_at',`${date_returned} ${time_returned}`,'info01')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{$invoiceTools.formatDateHours(returnInfo.returned_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return.organization_number') }}</th>
                <td>{{returnInfo.reference_number}}</td>
              </tr>
              <tr>
                <th>{{ translations('return.billing_address') }}
                </th>
                <td v-if="returnInfo.undeletable && !returnInfo.client_id && !returnInfo.client_name">
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >{{ returnInfo.bill_to_id && returnInfo.bill_to_id.name ? returnInfo.bill_to_id.name : '----------'}}</button>
                  <div id='popover-info03' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return.billing_address') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_bill_to" label="name" value="id" v-model="tempInfo.bill_to_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('bill_to_id',tempInfo.bill_to_id,'info03')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{returnInfo.client_name}}</td>
              </tr>
              <tr>
                <th>{{ translations('return.delivery_address') }}</th>
                <td v-if="returnInfo.undeletable && !returnInfo.client_id && !returnInfo.client_name">
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ returnInfo.destinations_id && returnInfo.destinations_id.name ? returnInfo.destinations_id.name : '----------'}}</button>
                  <div id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return.delivery_address') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="destinations" label="name" value="id" v-model="tempInfo.destinations_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('destinations_id',tempInfo.destinations_id,'info04')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{returnInfo.destination_name}}</td>
              </tr>
              <tr>
                <th>{{ translations('return.warehouse') }}</th>
                <td>{{returnInfo.warehouse_name}}</td>
              </tr>
              <tr>
                <th>{{ translations('return.remarks') }}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ returnInfo.memo || '----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return.remarks') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('common.last_updated_by') }}</th>
                <td>{{returnInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{ translations('common.last_update_time') }}</th>
                <td>{{ $invoiceTools.formatDateTime(returnInfo.updated_at) }}</td>
              </tr>
              <tr>
                <th class="is_processed">{{ translations('return.processing_status') }}</th>
                <td>
                  <button type="button" class="btn btn-primary btn-sm" v-if="Number(returnInfo.is_processed) === 0" v-on:click="clickIsProcessed()">
                    {{ translations('return.mark_processed') }}</button>
                  <button type="button" class="btn btn-primary btn-sm" v-else v-on:click="clickIsProcessed()">{{ translations('return.revert_unprocessed') }}</button>
                </td>
              </tr>
              <tr>
                <th>{{ Number(returnInfo.closing_flag) ? translations('return.closing_date') : translations('return.scheduled_closing_date') }}</th>
                <td>{{ $invoiceTools.formatDateTime(returnInfo.closing_at) }}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteReturn()" href='javascript:;'>{{ translations('common.delete') }}</a>
            </div>
          </div>
          <hr>
          <div>
            <h5 class='mb-3'>Check list</h5>
            <div class='padding-inline-start-5px'>
              <div>◎{{translations('return.best_condition')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.sealed_item')}}</li>
                </ul>
              </div>
              <div>○{{translations('return.good_condition')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.unopened_unused')}}</li>
                </ul>
              </div>
              <div>△{{translations('return.usable')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.functional_item')}}</li>
                </ul>
              </div>
              <div>×{{translations('return.not_usable')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.immovable_damaged')}}</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- UPLOAD TEMPLATE -->
          <div class="upload-file-evident">
            <input @change="selectFileEvident" ref="inputUploadFile" type="file" multiple class="mr-2" accept="application/pdf, image/png, image/jpeg, image/jpg">
            <button @click="uploadFileEvident" class="v-btn v-btn--contained theme--light v-size--small mt-2">{{ translations('return.upload') }}</button>
          </div>
           <button v-if="evidentList.length" style="margin-top:15px" class="btn v-btn v-btn--contained" @click="showModalReturnFile">
             {{ translations('return.files') }}</button>
          <!-- UPLOAD TEMPLATE -->
        </div>
        <div class='right-container'>
<!--          <div v-if="hasSetItem && returnInfo.client_id !== -2" class="alert alert-primary d-flex align-items-center">-->
<!--            <button class="btn btn-sm btn-primary mr-3" type="button" data-toggle="modal" data-target="#SingleReturnsModal">セット品をバラす</button>-->
<!--            <ul id="set-item-list">-->
<!--              <li v-for="(item, i) in setItems" :key="i"><span class="font-weight-bold">{{ item.model }}</span></li>-->
<!--            </ul>-->
<!--          </div>-->
          <div class="form-inline justify-content-end">
            <div class="form-group mr-3">
              <span class="font-weight-bold mb-0" style="font-size:16px;">単価合計： {{ displayGrandTotal(grandTotalUnitPriceDetail, grandTotalUnitPriceIncTaxDetail) }}  </span>
            </div>
            <div class="form-group">
              <span class="font-weight-bold mb-0" style="font-size:16px;">負債額合計： {{ displayGrandTotal(grandTotalDebtDetail, grandTotalDebtIncTaxDetail) }}  </span>
            </div>
          </div>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{ translations('common.tax_included') }}</div><!-- TAXSTATUS -->
            <div v-else>{{ translations('common.tax_excluded') }}</div>
          </div>
          <div class='table-scroll mb-2'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <input :checked="printAllChecked" type="checkbox" @change="onChangePrintAll"/>
                    <label for="checkallPrint">{{ translations('return.print') }}</label>
                  </th>
                  <th class="statusAllChecked"><input :checked="inputAllChecked" type="checkbox" @change="onChangeInputAll"/></th>
                  <th>
                    <label for="checkallStatus">{{ translations('return.return_status') }}</label>
                  </th>
<!--                  <th>操作</th>-->
                  <th>{{ translations('return.reason_return') }}</th>
                  <th>{{ translations('return.operation_confirmation') }}</th>
                  <th>{{ translations('return.verification_results') }}</th>
                  <th>{{ translations('return.model_number') }}</th>
                  <th>{{ translations('return.tax_classification') }}</th><!-- TAXSTATUS -->
                  <th>{{ translations('return.number_item') }}</th>
                  <th class="width-50-px">{{ translations('return.unit_price') }}</th>
                  <th class="width-50-px"></th>
                  <th>{{ translations('return.original_unit_price') }}</th>
                  <th>{{ translations('return.summary') }}</th>
                  <th>{{ translations('return.unit_price_total') }}</th>
                  <th>{{ translations('return.total_liabilities') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in returnDetails'>
                  <tr v-if="Number(detail.set_status) !== 2" :key='i'>
                    <td>
                      <!-- 未処理のみ削除可能 -->
                      <button for="checkStatus" v-if="!Number(returnInfo.closing_flag) && Number(detail.return_status_id) === 1" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>

                    <td>
                      <input for="checkStatus" type="checkbox" :checked="detail.print" name="change-print" :value="detail.id" @change="onChangeInputsPrint"/>
                    </td>

                    <td>
                      <input for="checkStatus" type="checkbox" :checked="detail.status" name="change-status" :value="detail.id" @change="onChangeInputs"/>
                    </td>

                    <td>
                      <button v-if="detail.is_shipped_replacement === 0" type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-info000' + i" data-placement='right'>
                        {{ (detail.return_status_id) ? getRetrunPropsById(return_statuses, detail.return_status_id, 'name') : '-------------' }}
                      </button>
                      <span v-else class='btn btn-link p-0' >{{ translations('return.exchanged') }}</span>
                      <div :ref="'info000' + i" :id="'popover-info000' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('return.return_status') }}</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].return_status_id" class="custom-select">
                            <template v-for="(status, i) in return_statuses">
                              <!-- 破棄済以外 -->
                              <option v-if="status.id !== 8" :key="i" :value="status.id">{{ status.name }}</option>
                              <option v-else-if="Number(detail.return_status_id) === 8" :key="i" :value="status.id">{{ status.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeStatus(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>

<!--                    <td>-->
<!--                      <button v-if="Number(detail.quantity)!==0 && Number(detail.is_moved)===0 && processType(detail)==='move' && Number(detail.is_shipped_replacement) === 0" class="btn-primary btn-sm borderless" @click="moveWarehouse(detail)">在庫移動</button>-->
<!--                      <button v-else-if="Number(detail.return_status_id)!==2 && Number(detail.return_status_id)!==6 && Number(detail.quantity)===0 && Number(detail.to_warehouse_id)" class="btn btn-link p-0 no_link" >{{ warehouseName(detail.to_warehouse_id) }}から不良品出荷済み</button>-->
<!--                      <button v-else-if="Number(detail.return_status_id)!==2 && Number(detail.return_status_id)!==6 && Number(detail.quantity)===0" class="btn btn-link p-0 no_link" >不良品出荷済み</button>-->
<!--                      <button v-else-if="Number(detail.is_moved)===1 && Number(detail.to_warehouse_id) && Number(detail.quantity)!==0 && Number(detail.return_status_id)!==8" class="btn btn-link p-0" @click="moveWarehouse(detail)">{{ warehouseName(detail.to_warehouse_id) }}へ移動済</button>-->
<!--                      <button v-else-if="Number(detail.is_moved)===1 && Number(detail.to_warehouse_id) && Number(detail.return_status_id)!==8" class="btn btn-link p-0 no_link">{{ warehouseName(detail.to_warehouse_id) }}へ移動済</button>-->
<!--                      <button v-else-if="processType(detail)==='discard'" class="btn-danger btn-sm borderless" @click="discardDetail(detail)">破棄</button>-->
<!--                    </td>-->

                    <td>
                      <button v-if="detail.is_shipped_replacement === 0" type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-reason' + i" data-placement='right'>
                        {{ (detail.return_reason_id) ? getRetrunPropsById(return_reasons, detail.return_reason_id, 'name') : '-------------' }}
                      </button>
                      <span v-else class='btn btn-link p-0'>
                        {{ (detail.return_reason_id) ? getRetrunPropsById(return_reasons, detail.return_reason_id, 'name') : '-------------' }}
                      </span>
                      <div :ref="'reason' + i" :id="'popover-reason' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>
                          {{ translations('return.reason_return') }}</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].return_reason_id" class="custom-select">
                            <template v-for="(reason, i) in reasons">
                              <!-- 破棄済以外 -->
                              <option :key="i" :value="reason.id">{{ reason.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeReason(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                    </td>

                    <td>
                      <button v-if="detail.is_shipped_replacement === 0"
                              type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info0000' + i"
                        data-placement='right'
                      >{{ (detail.return_state_id) ? getRetrunPropsById(return_states, detail.return_state_id, 'name') : '-------------' }}</button>
                      <span v-else class='btn btn-link p-0' >{{ (detail.return_state_id) ? getRetrunPropsById(return_states, detail.return_state_id, 'name') : '-------------' }}</span>
                      <div :ref="'info0000' + i" :id="'popover-info0000' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('return.operation_confirmation') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetails[i].return_state_id" class="custom-select">
                            <!-- <option selected value="">-</option> -->
                            <template  v-for="(state, i) in return_states">
                              <option :key="i" :value="state.id">{{ state.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeState(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>

                    <td>
                      <button v-if="detail.is_shipped_replacement === 0"
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-test_result' + i"
                        data-placement='right'
                        style="max-width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                        :title="getTextResult(detail)"
                      >{{getTextResult(detail)}}</button>
                      <span v-else class="btn btn-link p-0">{{getTextResult(detail)}}</span>
                      <div :ref="'popover-test_result' + i" :id="'popover-test_result' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('return.verification_results') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <textarea class='form-control' v-model="tempDetails[i].test_result"></textarea>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeTestResult(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>

                    <td>{{ (typeof detail.model === 'number') ? getRetrunPropsById(products, detail.model, 'model') : detail.model }}</td>

                    <td v-if="!Number(returnInfo.closing_flag) && detail.is_shipped_replacement === 0">
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangeTaxclass(detail)">
                        <option value="1">{{ translations('return.taxable_item') }}</option>
                        <option value="2">{{ translations('return.not_applicable') }}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td v-else>{{ detail.taxclass_id === 1 ? translations('return.taxable_item') : translations('return.not_applicable') }}</td>

                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>

                    <td v-if="!Number(returnInfo.closing_flag) && detail.is_shipped_replacement === 0">
                      <div v-if="!taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" :id="'unit_price' + i" @focus="refresh('unit_price' + i)" @blur="refresh('unit_price' + i)" @input="onChangePrice('unit_price', detail)" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                      <div v-if="taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price_inctax" :id="'unit_price_inctax' + i" @focus="refresh('unit_price_inctax' + i)" @blur="refresh('unit_price_inctax' + i)" @input="onChangePrice('unit_price_inctax', detail)" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price_inctax && detail.unit_price_inctax.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td v-else>{{ toTaxFormat(detail, 'unit_price') }}</td>

                    <td v-if="Number(detail.taxclass_id) === 1 && detail.is_shipped_replacement === 0" class="right">
                      ({{ toUnitPriceTaxLabel(detail) }})
                    </td>
                    <td v-else></td>

                    <td class="right" v-if="detail.is_shipped_replacement === 0">
                      <div class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" @input="numbers(i,'row_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.row_price" @focus="refresh('row_price')" @blur="refresh('row_price')" /><!-- 既存の class に number-input 追記 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.row_price && detail.row_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td class="right" v-else>
                        <span>{{ detail.row_price && detail.row_price.toLocaleString() }}</span>
                    </td>

                    <td class="right">
                      <input v-if="detail.is_shipped_replacement === 0" type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks" @change="onChangeRemarks(detail)"/>
                      <span v-else>{{ detail.remarks}}</span>
                    </td>

                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ Number(detail.return_status_id) !== 8 ? toTaxFormat(detail, 'total_cost') : 0 }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td v-if="!Number(returnInfo.closing_flag)">
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReturnsModal'><i></i></button>
                  </td>
                  <td v-else></td>
                  <td></td>
                  <td></td>
<!--                  <td></td>&lt;!&ndash; TAXSTATUS &ndash;&gt;-->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalDebt, grandTotalDebtIncTax) }}</td>
                </tr>
              </tbody>
            </table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
          </div>
          <div class="form-inline mb-4">
            <div class="form-group mr-2">
              <select v-model="changeStatusId" class="custom-select">
                <template v-for="(status, i) in return_statuses">
                  <!-- 破棄済以外 -->
                  <option v-if="status.id !== 8" :key="i" :value="status.id">{{ status.name }}</option>
                </template>
              </select>
            </div>
            <div class="form-group">
              <button :disabled="isStatusDisable" class='btn btn-sm btn-primary' @click="updateStatusMulti()">
                {{ translations('return.bulk_status_change') }}</button>
              <button :disabled="isPrintDisable" class='btn btn-sm btn-primary ml-1' @click="printRediect()">{{ translations('return.tuck_seal_printing') }}</button>
<!--              <button style="margin-left:10px;" :disabled="isLastConfirm === '1'" v-if="isShowLastConfirm" class='btn btn-sm btn-primary' @click="confirmLastReturn()">{{ isLastConfirm === '1' ?'確定済み':'確定'}}</button>-->
              <button style="margin-left:5px;" :disabled="isLastConfirm === '1'" class='btn btn-sm btn-primary' @click="confirmLastReturn()">{{ isLastConfirm === '1' ? translations('return.confirmed') : translations('return.confirm')}}</button>
            </div>
          </div>

          <div class='form-inline form-line-po'>
            <div v-if="!Number(returnInfo.closing_flag)" class='form-group mr-2'>
              <!-- 追加か削除された場合にのみ有効化 -->
              <button :disabled="!isAddOrDelete" @click="updateReturn()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
            </div>
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline" href="javascript:;" @click="openDeliverySlip">{{ translations('return.return_slip_printing') }}<i class="fas fa-external-link-alt"></i></a>
            </div>
<!--            <button :disabled="isConfirmReturn" @click="askAdminReview()" class='btn btn-sm btn-primary'>承認申請</button>-->

<!--              <button-->
<!--                  ref='statusEmail'-->
<!--                  type='button'-->
<!--                  class='show_status'-->
<!--                  data-toggle='popover-x'-->
<!--                  data-target='#popover-status-email'-->
<!--                  data-placement='right'-->
<!--                >承認まち-->
<!--              </button>-->
<!--              <div id='popover-status-email' class='popover popover-x popover-default'>-->
<!--                <div class='arrow status'></div>-->
<!--                <div class='popover-body d-flex status'>-->
<!--                  <button class='close status' data-dismiss='popover-x'>&times;</button>-->
<!--                  <ul style="margin:0">-->
<!--                    <li class="list-status" v-for="(status, i) in adminStatus" :key="i">-->
<!--                      <span class="admin-name">{{status.user_name }}</span>-->
<!--                      <span v-bind:class="{ 'text-status': status.status === '1' }" class="status-space">{{ status.status === '1' ? '承認済み' : '未承認'}}</span>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->

<!--              <button @click="adminApprove()" :disabled="isApprivedDisable" v-if="isShowButtonApproved" class='btn btn-sm btn-primary isShowButtonApproved'>承認する</button>-->
          </div>
        </div>
      </div>
    </div>
    <NewReturnsModal
      :returnDetails='returnDetails'
      :returnStatuses="return_statuses"
      :returnReasons="return_reasons"
      :returnStates="return_states"
      :products="products"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    /><!-- VAT -->
    <SingleReturnsModal :setItems="setItems" :return_id="returnId" :returnDetails='returnDetails'/>
    <SingleReturnMoveModal :warehouses="warehouses" :warehouseId="returnInfo.warehouses_id" :detail="selectedDetail"/>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
    <ReturnDownloadFilesModal ref="returnModalComponent" :setEvidentFileDelete="setEvidentFileDelete"/>

  </div>
</template>

<script>
import $ from 'jquery' // number-container
import { format } from 'date-fns'
import VueElementLoading from 'vue-element-loading'
import NewReturnsModal from '@/components/NewReturnsModal'
import SingleReturnsModal from '@/components/SingleReturnModal'
import SingleReturnMoveModal from '@/components/SingleReturnMoveModal'
import ReturnDownloadFilesModal from '@/components/ReturnDownloadFilesModal'
import _ from 'lodash'
import axios from 'axios'
import { ReasonReturn } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'SingleReturn',
  props: {},
  components: {
    VueElementLoading,
    NewReturnsModal,
    SingleReturnsModal,
    SingleReturnMoveModal,
    ReturnDownloadFilesModal
  },
  watch: {
    returnDetails: {
      handler (v) {
        this.tempDetails = JSON.parse(JSON.stringify(v))
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
        this.withSetItem()
        this.refresh('row_price') // 原価
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    },
    allReturnDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareTotalDetails(d)
          }
        })
        this.calcGrandTotalsDetail()
        this.refresh('row_price') // 原価
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    },
    'tempInfo.bill_to_id' (newId, oldId) {
      if ((newId && oldId) && (newId.id === oldId.id)) return

      if (oldId) {
        this.tempInfo.destinations_id = {
          name: '',
          id: '0'
        }
        this.updateField('destinations_id', '', 'info04')
      }

      this.listDestinations()
    },
    page () {
      this.changeIds = []
      this.printAllChecked = false
      this.inputAllChecked = false
      this.getReturnDetails()
      window.scrollTo(0, 0)
    }
  },
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT // TAXSTATUS (TROUBLESHOOTING)
      returnId: '',
      isLoading: false,
      returnInfo: {},
      returnDetails: [],
      tempInfo: {},
      tempDetails: [],
      originalInfo: {},
      originalDetails: [],
      destinations: [],
      delivery_destinations: [],
      products: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalDebt: 0,
      grandTotalDebtIncTax: 0,
      grandTotalUnitPriceDetail: 0,
      grandTotalUnitPriceIncTaxDetail: 0,
      grandTotalDebtDetail: 0,
      grandTotalDebtIncTaxDetail: 0,
      setItems: [],
      selectedDetail: null,
      clickAddDetail: false,
      deliveryFile: null,
      changeIds: [],
      changeStatusId: 0,
      date_arrived: null,
      time_arrived: null,
      date_returned: null,
      time_returned: null,
      printAllChecked: false,
      isPrintDisable: true,
      inputAllChecked: false,
      isStatusDisable: true,
      evidentFile: [],
      evidentList: [],
      isConfirmReturn: false,
      adminStatus: [],
      isShowButtonApproved: false,
      isApprivedDisable: false,
      isShowLastConfirm: false,
      isLastConfirm: false,
      page: 1,
      totalCount: 0,
      itemsPerPage: 300,
      pageCount: 1,
      allReturnDetails: [],
      returnDetailsCurrentPage: []
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    clients () {
      return this.$store.getters['Master/getBillTo']
    },
    warehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    processType: function () {
      const self = this
      return function (detail) {
        // -1:自社移動, -2:お客様交換用（不良品破棄） かつ 破棄待ち/破棄済以外
        if (self.returnInfo.client_id === -1) {
          let action = ''
          switch (detail.return_status_id) {
            case self.$const['RETURN_PROCESS_未処理']:
            case self.$const['RETURN_PROCESS_新品']:
            case self.$const['RETURN_PROCESS_相殺待ち']:
            case self.$const['RETURN_PROCESS_相殺済み']:
            case self.$const['RETURN_PROCESS_代替待ち']:
            case self.$const['RETURN_PROCESS_代替済み']:
            case self.$const['RETURN_PROCESS_アウトレット']:
              action = 'move'
              break
            case self.$const['RETURN_PROCESS_破棄待ち']:
              action = 'discard'
              break
          }
          return action
        }

        let action = ''
        switch (detail.return_status_id) {
          case self.$const['RETURN_PROCESS_新品']:
          case self.$const['RETURN_PROCESS_相殺済み']:
          case self.$const['RETURN_PROCESS_代替済み']:
          case self.$const['RETURN_PROCESS_アウトレット']:
            action = 'move'
            break
          case self.$const['RETURN_PROCESS_破棄待ち']:
            action = 'discard'
            break
        }
        return action
      }
    },
    warehouseName: function () {
      const self = this
      return function (warehouseId) {
        const warehouse = self.warehouses.find((item) => item.id === Number(warehouseId))
        return warehouse ? warehouse.name : '不明な倉庫'
      }
    },
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_statuses () {
      const statuses = this.$store.getters['Return/getStatuses']
      return this.translateStatuses(statuses)
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    isAddOrDelete () {
      return JSON.stringify(this.returnInfo) !== JSON.stringify(this.originalInfo) || JSON.stringify(this.returnDetails.map(detail => detail.id)) !== JSON.stringify(this.originalDetails.map(detail => detail.id))
    },
    hasSetItem () {
      return this.returnDetails.filter(detail => detail.set_status === 1).length > 0
    },
    master_bill_to () {
      return this.$store.getters['Master/getBillToNewreturn']
    },
    isChangeIds () {
      return this.changeIds.length > 0
    },
    reasons () {
      const returnReasons = this.$store.getters['Return/getReasons']
      let reasons = []
      returnReasons.forEach(reason => {
        if (reason['is_temporary'] === ReasonReturn.reason) {
          reasons.push(reason)
        }
      })
      return reasons
    }
  },
  created () {
    if (!this.$route.query.return_id) {
      this.$router.replace('archive-return')
      return
    }

    this.returnId = this.$route.query.return_id

    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Return/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkBillTo')
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkBillToNewreturn')

    this.getReturnDetails().catch(error => {
      this.$toastr.error(error.message, 'エラー')
    }).finally(() => {
      this.popoverButtons()
    })
  },
  mounted () {
    let pageBack = this.$router.history.current.query.pageBack
    if (pageBack) {
      window.onpopstate = () => {
        window.location.href = `archive-return?page=${pageBack}`
        return false
      }
    }
    this.getAllReturnDetail()
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    async confirmLastReturn () {
      if (this.isLastConfirm === '1') {
        return false
      }
      let isMoved = false
      let changeIds = []
      for (let index = 0; index < this.returnDetails.length; index++) {
        changeIds.push({
          'id': this.returnDetails[index].id,
          'status': this.returnDetails[index].return_status_id })
      }
      changeIds.forEach(eachReturn => {
        const detail = this.returnDetails.find(d => d.id === Number(eachReturn.id))
        // 在庫が移動済のステータスになっている明細の「ステータス」を変更しようとした場合
        if (Number(detail.is_moved) === 1) {
          isMoved = true
        }
      })
      if (isMoved) {
        const result = await new Promise((resolve, reject) => {
          this.$dialog.confirm(this.translations('return.notice_move_return_delete')).then(() => {
            resolve({ data: true })
          }, () => {
            resolve({ data: false })
          })
        })
        if (!result.data) {
          return
        }
      }
      const mapReturnDetails = new Map()
      changeIds.forEach(changeId => {
        mapReturnDetails.set(changeId.id, changeId)
      })

      const allReturnDetails = this.allReturnDetails.map(returnDetail => {
        const mapReturnDetail = mapReturnDetails.get(returnDetail.id)
        if (mapReturnDetail) {
          return { ...returnDetail, ...mapReturnDetail }
        }
        return returnDetail
      })

      this.isLoading = true
      const formData = new FormData()
      formData.append('return_detail_ids', JSON.stringify(allReturnDetails))
      formData.append('return_id', this.returnId)
      this.$http.post(this.$api_url.return_last_confirm_change_status, formData).then(response => {
        const result = response.data
        if (result.status) {
          console.log(result.list)
          result.list.forEach(data => {
            const detail = this.returnDetails.find(d => d.id === Number(data.detail_id))
            if (detail) {
              detail.return_status_id = Number(data.return_status_id)
              detail.is_moved = Number(data.is_moved)
            }
          })
          this.isLastConfirm = '1'
          this.$toastr.success(this.translations('return.updated'), this.translations('common.success'))
        } else {
          this.$toastr.error(result.message, this.translations('return.process_fail'))
          result.list.forEach(data => {
            const detail = this.returnDetails.find(d => d.id === Number(data.detail_id))
            if (detail) {
              detail.return_status_id = data.old_id
            }
          })
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    adminApprove () {
      this.isLoading = true
      const formData = new FormData()
      formData.append('return_id', this.returnId)
      formData.append('url_return', window.location.href)
      formData.append('created_by', this.returnInfo.created_by)

      this.$http.post(this.$api_url.return_admin_approve_email, formData).then(response => {
        this.isLoading = false
        const result = response.data
        if (!result || result.status !== true) {
          this.$toastr.error(this.translations('return.message_error`') + result.message, this.translations('common.error'))
        } else {
          this.isApprivedDisable = true
          let defaultStatus = this.adminStatus
          for (let index = 0; index < defaultStatus.length; index++) {
            if (this.$store.getters['User/data']['email'] === defaultStatus[index].email) {
              defaultStatus[index].status = '1'
            }
          }
          this.adminStatus = defaultStatus
          if (result.open_last_confirm === true) {
            this.isLastConfirm = '0'
            this.isShowLastConfirm = true
          }
        }
      })
    },
    askAdminReview () {
      this.isLoading = true
      const formData = new FormData()
      formData.append('url_return', window.location.href)
      formData.append('return_id', this.returnId)
      this.$http.post(this.$api_url.return_ask_admin_email, formData).then(response => {
        this.isLoading = false
        const result = response.data
        if (!result || result.status !== true) {
          this.$toastr.error(this.translateStates('return.message_error') + result.message, this.translations('common.error'))
        } else {
          let defaultStatus = this.adminStatus
          for (let index = 0; index < defaultStatus.length; index++) {
            defaultStatus[index].status = '0'
          }
          this.adminStatus = defaultStatus
          this.isLastConfirm = '0'
          this.isShowLastConfirm = false
          this.isConfirmReturn = true
          this.$toastr.success(this.translations('return.notice_send_mail_success'), this.translations('common.success'))
        }
      })
    },
    selectFileEvident (e) {
      e.preventDefault()
      const files = e.target.files
      this.evidentFile = files
    },
    showModalReturnFile () {
      this.$refs.returnModalComponent.setFiles(this.evidentList)
      window.$('#returnDownloadFilesModal').modal('show')
    },
    uploadFileEvident () {
      let validate = this.validateFileUpload()

      if (validate.result === false) {
        alert(validate.message)
        this.$refs.inputUploadFile.value = null
        return false
      }

      const formData = new FormData()
      formData.append('return_id', this.returnId)
      for (let index = 0; index < this.evidentFile.length; index++) {
        formData.append('files[]', this.evidentFile[index])
      }
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      this.isLoading = true
      this.$http.post(this.$api_url.return_upload_evident, formData, config).then(response => {
        const result = response.data
        this.$refs.inputUploadFile.value = null
        if (!result || result.status !== true) {
          this.$toastr.error(this.translations('return.message_error') + result.message, this.translations('common.error'))
        } else {
          this.evidentList = result.data
          this.$toastr.success(this.translations('return.notice_upload_success'), this.translations('common.success'))
        }
      }).catch(err => {
        this.$toastr.error(this.translations('return.message_error') + err.message, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
        this.evidentFile = []
      })
    },
    validateFileUpload () {
      if (this.$refs.inputUploadFile.files.length > 10) {
        return {
          'message': this.translations('return.notice_upload_ten_files'),
          'result': false
        }
      }
      let size = 0
      for (let index = 0; index < this.$refs.inputUploadFile.files.length; index++) {
        size += this.$refs.inputUploadFile.files[index].size
      }
      size = size / 1024 / 1024
      if (size > 20) {
        return {
          'message': this.translations('return.notice_upload_file_less_20MB'),
          'result': false
        }
      }
      if (!this.evidentFile || this.evidentFile.length === 0) {
        return {
          'message': this.translations('return.message_choose_file'),
          'result': false
        }
      }

      for (let index = 0; index < this.evidentFile.length; index++) {
        let type = this.evidentFile[index].type
        let listFile = [ 'application/pdf', 'image/png', 'image/jpeg', 'image/jpg' ]
        if (listFile.indexOf(type) === -1) {
          return {
            'message': this.translations('return.file_format_error'),
            'result': false
          }
        }
      }
      return {
        'result': true
      }
    },
    setEvidentFileDelete (data) {
      this.evidentList = data
    },
    getReturnDetails () {
      this.isLoading = true
      const offset = (this.page - 1) * this.itemsPerPage
      let params = {
        offset: offset,
        limit: this.itemsPerPage,
        return_id: this.returnId
      }
      return this.$http.post(this.$api_url.return_details, params).then(response => {
        const result = response.data
        this.returnDetailsCurrentPage = result.details
        this.totalCount = Number(result.total_count)
        this.pageCount = _.ceil(this.totalCount / this.itemsPerPage)
        if (result.status === true) {
          this.returnInfo = result.information
          let details = result.details.map(function (elem) {
            elem.print = false
            elem.status = false
            return elem
          })
          this.returnDetails = details
          this.returnDetails = result.details
          this.evidentList = result.fileEvident
          this.adminStatus = result.adminStatus
          this.taxIncluded = result.information.tax_included
          this.vatRate = result.information.tax_rate

          this.tempInfo = JSON.parse(JSON.stringify(this.returnInfo))
          this.tempDetails = JSON.parse(JSON.stringify(this.returnDetails))

          this.originalInfo = JSON.parse(JSON.stringify(this.returnInfo))
          this.originalDetails = JSON.parse(JSON.stringify(this.returnDetails))

          this.date_arrived = format(new Date(result.information.arrived_at), 'yyyy-MM-dd')
          this.time_arrived = format(new Date(result.information.arrived_at), 'HH:mm')
          this.date_returned = format(new Date(result.information.arrived_at), 'yyyy-MM-dd')
          this.time_returned = format(new Date(result.information.arrived_at), 'HH:mm')
          const emailAdmin = [
            'sato@uniqstyle.co.jp',
            'kawakatsu@uniqstyle.co.jp',
            'oshika@uniqstyle.co.jp',
            'kentaro@uniqstyle.co.jp'
          ]
          this.isShowButtonApproved = false
          if (result.information.is_send_mail === '1') {
            this.isConfirmReturn = true
          }
          console.log(this.$store.getters['User/data']['email'])
          if (result.information.is_send_mail === '1' && emailAdmin.includes(this.$store.getters['User/data']['email']) !== false) {
            this.isShowButtonApproved = true
          }
          let indexIsApproved = _.findIndex(this.adminStatus, (o) => { return o.email === this.$store.getters['User/data']['email'] })

          if (indexIsApproved !== -1) {
            this.isApprivedDisable = this.adminStatus[indexIsApproved].status === '1'
          }
          this.isShowLastConfirm = (_.findIndex(this.adminStatus, (o) => { return o.status === '0' }) === -1)
          this.isLastConfirm = result.information.is_last_confirm
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch((error) => {
        console.log('SingleReturn:getReturnDetails:catch(error): ', error)
        return Promise.reject(new Error(this.translations('return.notice_failed')))
      }).finally(() => {
        this.isLoading = false
      })
    },

    getAllReturnDetail () {
      this.isLoading = true
      let params = {
        return_id: this.returnId,
        is_all: true
      }
      this.$http.post(this.$api_url.return_details, params).then(response => {
        const result = response.data
        if (result || result.status === true) {
          this.allReturnDetails = result.details
        }
      }).catch(err => {
        this.$toastr.error(this.translations('return.message_error') + err.message, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
        this.evidentFile = []
      })
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_unit_price_inctax = data.quantity * data.unit_price_inctax

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        if (!this.taxIncluded) { // 税抜
          data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        } else {
          data.total_unit_price = this.$util.getIncludeTax(data.total_unit_price_inctax, data.tax_rate)
        }
      }

      return data
    },

    prepareTotalDetails (data) {
      data.total_cost_detail = data.quantity * data.row_price
      data.total_unit_price_detail = data.quantity * data.unit_price
      data.total_unit_price_inctax_detail = data.quantity * data.unit_price_inctax

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax_detail = data.total_cost_detail
        data.total_unit_price_inctax_detail = data.total_unit_price_detail
      } else {
        data.total_cost_inctax_detail = this.$util.getIncludeTax(data.total_cost_detail, data.tax_rate)
        if (!this.taxIncluded) { // 税抜
          data.total_unit_price_inctax_detail = this.$util.getIncludeTax(data.total_unit_price_detail, data.tax_rate)
        } else {
          data.total_unit_price_detail = this.$util.getIncludeTax(data.total_unit_price_inctax_detail, data.tax_rate)
        }
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0

      this.returnDetails.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPrice += Number(v.total_unit_price)
          if (v.return_status_id === 1) {
            this.grandTotalDebt += Number(v.total_cost)
          }
        } else {
          this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
          if (v.return_status_id === 1) {
            this.grandTotalDebtIncTax += Number(v.total_cost_inctax)
          }
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
        this.grandTotalDebtIncTax = this.$util.getIncludeTax(this.grandTotalDebt, this.taxRate)
      } else {
        this.grandTotalUnitPrice = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTax, this.taxRate)
        this.grandTotalDebt = this.$util.getExcludeTax(this.grandTotalDebtIncTax, this.taxRate)
      }
    },

    calcGrandTotalsDetail () {
      this.grandTotalUnitPriceDetail = 0
      this.grandTotalDebtDetail = 0

      this.allReturnDetails.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPriceDetail += Number(v.total_unit_price_detail)
          if (v.return_status_id === 1) {
            this.grandTotalDebtDetail += Number(v.total_cost_detail)
          }
        } else {
          this.grandTotalUnitPriceIncTaxDetail += Number(v.total_unit_price_inctax_detail)
          if (v.return_status_id === 1) {
            this.grandTotalDebtIncTaxDetail += Number(v.total_cost_inctax_detail)
          }
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTaxDetail = this.$util.getIncludeTax(this.grandTotalUnitPriceDetail, this.taxRate)
        this.grandTotalDebtIncTaxDetail = this.$util.getIncludeTax(this.grandTotalDebtDetail, this.taxRate)
      } else {
        this.grandTotalUnitPriceDetail = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTaxDetail, this.taxRate)
        this.grandTotalDebtDetail = this.$util.getExcludeTax(this.grandTotalDebtIncTaxDetail, this.taxRate)
      }
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.returnDetails[index][target] = this.returnDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },

    openAddDetailModal () {
      this.getProducts()
    },

    async getBoundProduct () {
      try {
        const response = await this.$http.post(this.$api_url.return_bound_product, { return_id: this.returnId })
        const result = response.data
        if (result.status === true) {
          this.setItems = result.list
        } else {
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SingleReturn:getBoundProduct:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },

    async openDeliverySlip () {
      if (!this.deliveryFile) {
        try {
          const response = await this.$http.post(this.$api_url.return_delivery_slip, { return_id: this.returnId })
          const result = response.data
          if (result.status === true && result.slip) {
            this.deliveryFile = result.slip
          } else {
            this.$toastr.error(result.message, this.translations('common.error'))
          }
        } catch (error) {
          console.log('SingleReturn:openDeliverySlip:catch(error): ', error)
          this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
        }
      }

      if (this.deliveryFile) {
        let arrBuff = this.__b64ToArrayBuffer(this.deliveryFile.replace('data:application/pdf;base64,', ''))
        const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
        const deliveryFileURL = URL.createObjectURL(deliveryFile)
        window.open(deliveryFileURL)
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
      return Promise.resolve()
    },

    getTextResult (detail) {
      return detail.test_result ? detail.test_result : '-------------'
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (
        !value ||
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '----------'
        val = ''
      } else if (field === 'returned_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'arrived_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'warehouses_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.warehouses.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'client_id') {
        this.clients.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            // $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else if (field === 'destinations_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'bill_to_id') {
        this.master_bill_to.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.returnInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    moveWarehouse (value) {
      this.selectedDetail = value
      window.$('#SingleReturnMoveModal').modal('show')
    },

    deleteDetail (i) {
      this.returnDetails.splice(i, 1)
    },

    async getProducts () {
      this.isLoading = true
      try {
        const params = {
          bill_to_id: this.tempInfo.client_id,
          arrived_at: this.tempInfo.arrived_at
        }

        const products = await this.$http.post(this.$api_url.return_product_list, params)
        const $data = this.$invoiceTools.prepareResult(products.data, 'list', 'SingleReturn:getProducts')
        if ($data.success === true) {
          this.products = $data.data
          this.$refs.openAddDetailModal.click() // 成功時にモーダル表示
        } else {
          this.$toastr.error($data.data, this.translations('return.process_fail'))
        }
      } catch (error) {
        console.log('SingleReturn:getProducts:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      } finally {
        this.isLoading = false
      }
    },

    getRetrunPropsById (selection, id, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.id === id) {
          ret = val[name]
        }
      })
      return ret
    },

    async updateReturn () {
      try {
        if (!this.tempInfo.returned_at) {
          this.$toastr.warning(this.translations('return.notice_enter_return_date'))
          return
        }

        if (this.allReturnDetails.length < 1) {
          this.$toastr.warning(this.translations('return.notice_enter_details_line'))
          return
        }

        this.isLoading = true
        this.tempInfo.arrived_at = format(new Date(this.returnInfo.arrived_at), "yyyy-MM-dd'T'HH:mm:ss")
        this.tempInfo.returned_at = format(new Date(this.returnInfo.returned_at), "yyyy-MM-dd'T'HH:mm:ss")

        let originalDetails = this.originalDetails
        let returnDetailRemoves = originalDetails.filter(originalDetail => !this.tempDetails.some(tempDetail => originalDetail.id === tempDetail.id))
        let newReturnDetails = this.allReturnDetails.filter(allReturnDetail => !returnDetailRemoves.some(returnDetailRemove => allReturnDetail.id === returnDetailRemove.id))
        this.tempDetails.forEach(tempDetail => {
          if (!tempDetail.id) {
            newReturnDetails.push(tempDetail)
          }
        })
        let paramUpdate = {
          return_id: this.returnId,
          information: this.tempInfo,
          details: newReturnDetails
        }
        console.log(paramUpdate)
        let updateReturn = await this.$http.post(this.$api_url.return_update, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(updateReturn.data, 'list', 'SingleReturn:updateReturn')
        if ($data.success === true) {
          this.isConfirmReturn = false
          this.$toastr.success(this.translations('return.notice_save_success'), this.translations('common.success'))
          this.getReturnDetails()
          this.getAllReturnDetail()
          if (!this.tempDetails.length) {
            window.location.reload()
          }
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.printAllChecked = false
        this.isPrintDisable = true
        this.inputAllChecked = false
        this.isStatusDisable = true
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.printAllChecked = false
        this.isPrintDisable = true
        this.inputAllChecked = false
        this.isStatusDisable = true
        console.log('SingleReturn:updateReturn:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },

    async deleteReturn () {
      if (this.returnInfo.undeletable) {
        this.$toastr.warning(this.translations('return.notice_cannot_delete_return'))
        return false
      }

      this.$dialog.confirm(this.translations('return.notice_delete_return'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        try {
          this.isLoading = true
          let deleteReturn = await this.$http.post(this.$api_url.return_delete, { return_id: this.returnId })
          let $data = this.$invoiceTools.prepareResult(deleteReturn.data, '', 'SingleReturn:deleteReturn')
          if ($data.success === true) {
            this.$toastr.success(this.translations('return.notice_delete_success'), this.translations('common.success'))
            this.$router.replace({ name: 'archive-return' })
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          setTimeout(() => { this.isLoading = false }, 1000)
        } catch (error) {
          console.log('SingleReturn:deleteReturn:catch(error): ', error)
          this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
        }
      })
    },

    async discardDetail (detail) {
      this.$dialog.confirm('本当に破棄しますか?').then(async () => {
        this.isLoading = true
        const params = {
          return_detail_id: detail.id,
          return_status_id: this.$const['RETURN_PROCESS_破棄済み']
        }
        const self = this
        this.$http.post(this.$api_url.return_discard, params).then(function (response) {
          if (response.data.status) {
            self.$toastr.success('処理成功', 'Success')
            detail.is_moved = 1
            detail.return_status_id = self.$const['RETURN_PROCESS_破棄済み']
          } else {
            self.$toastr.error(response.data.message, '処理失敗')
          }
        }).finally(function () {
          self.isLoading = false
        })
      })
    },

    withSetItem () {
      let ret = 0
      this.tempDetails.forEach(val => {
        if (val.set_status === 1) {
          ret += 1
        }
      })
      if (ret) {
        this.getBoundProduct()
        return true
      }
      return false
    },

    // getSetItem () {
    //   let ret = []
    //   this.tempDetails.forEach(val => {
    //     console.log(val)
    //     if (val.is_set === 1) {
    //       ret.push(val)
    //     }
    //   })
    //   return ret
    // },

    async onChangeStatus (detail, i) {
      if (detail.return_status_id === this.tempDetails[i].return_status_id) {
        window.$('#popover-info000' + i).popoverX('hide')
        return
      }

      let deleteFlg = false
      // 在庫が移動済のステータスになっている明細の「ステータス」を変更しようとした場合
      if (detail.is_moved === 1) {
        const result = await new Promise((resolve, reject) => {
          this.$dialog.confirm(this.translations('return.notice_move_return_delete')).then(() => {
            resolve({ data: true })
          }, () => {
            resolve({ data: false })
          })
        })
        if (result.data) {
          deleteFlg = true
        } else {
          return
        }
      }

      this.updateField('return_status_id', this.tempDetails[i].return_status_id, ('info000' + i), detail)
      if (!detail.id) return

      this.isLoading = true

      const params = {
        return_detail_id: detail.id,
        return_status_id: detail.return_status_id,
        return_id: this.returnId,
        delete_flg: deleteFlg
      }
      const self = this
      this.$http.post(this.$api_url.return_change_status, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_status_updated'), this.translations('common.success'))
          detail.return_status_id = response.data.return_status_id
          detail.is_moved = response.data.is_moved
          self.isConfirmReturn = false
        } else {
          self.$toastr.error(response.data.message, this.translations('return.process_fail'))
          detail.return_status_id = response.data.old_id
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
        window.location.reload()
      })
    },
    onChangeState (detail, i) {
      this.updateField('return_state_id', this.tempDetails[i].return_state_id, ('info0000' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        return_state_id: detail.return_state_id
      }
      const self = this
      this.$http.post(this.$api_url.return_change_state, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_update_results_success'), this.translations('common.success'))
          detail.return_state_id = response.data.return_state_id
        } else {
          self.$toastr.error(response.data.message, this.translations('return.process_fail'))
          detail.return_state_id = response.data.old_return_state_id
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeReason (detail, i) {
      this.updateField('return_reason_id', this.tempDetails[i].return_reason_id, ('reason' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        return_reason_id: detail.return_reason_id
      }
      const self = this
      this.$http.post(this.$api_url.return_change_reason, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_update_reason_success'), this.translations('common.success'))
          detail.return_reason_id = response.data.return_reason_id
        } else {
          self.$toastr.error(response.data.message, this.translations('return.process_fail'))
          detail.return_reason_id = response.data.old_return_reason_id
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeTestResult (detail, i) {
      this.updateField('test_result', this.tempDetails[i].test_result, ('test_result' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        test_result: detail.test_result
      }
      const self = this
      this.$http.post(this.$api_url.return_change_test_result, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_update_test_results_success'), this.translations('common.success'))
          detail.test_result = response.data.test_result
        } else {
          self.$toastr.error(response.data.message, this.translations('return.process_fail'))
          detail.test_result = response.data.old_test_result
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },
    onChangeTaxclass (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        taxclass_id: detail.taxclass_id
      }
      const self = this
      this.$http.post(this.$api_url.return_change_taxclass, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_update_tax_rate_success'), this.translations('common.success'))
          detail.taxclass_id = response.data.taxclass_id
        } else {
          self.$toastr.error(response.data.message, this.translations('return.notice_update_failed'))
          detail.taxclass_id = response.data.old_taxclass_id
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    onChangeUnitPrice (detail) {
      if (!detail.id) {
        if (!detail.taxclass_id) detail.taxclass_id = 1
        if (Number(detail.taxclass_id) === 1) { // 税区分（1:課税対象, 2:対象外）
          if (!this.taxIncluded) {
            detail.unit_price_inctax = this.$util.getIncludeTax(detail.unit_price, detail.tax_rate)
          } else {
            detail.unit_price = this.$util.getExcludeTax(detail.unit_price_inctax, detail.tax_rate)
          }
        } else {
          detail.unit_price_inctax = detail.unit_price
        }
        return
      }

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        selling_price: detail.unit_price,
        selling_price_inctax: Number(detail.taxclass_id) === 1 ? this.$util.getIncludeTax(detail.unit_price, detail.tax_rate) : detail.unit_price
      }
      const self = this
      this.$http.post(this.$api_url.return_change_selling_price, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_update_unit_price_success'), this.translations('common.success'))
          detail.unit_price = response.data.selling_price
          detail.unit_price_inctax = response.data.selling_price_inctax
        } else {
          self.$toastr.error(response.data.message, this.translations('return.processing_failed'))
          detail.unit_price = response.data.old_selling_price
          detail.unit_price_inctax = response.data.old_selling_price_inctax
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    // onChangeQuantity (detail) {
    //   this.isLoading = true
    //   const params = {
    //     return_detail_id: detail.id,
    //     quantity: detail.quantity
    //   }
    //   const self = this
    //   this.$http.post(this.$api_url.return_change_quantity, params).then(function (response) {
    //     if (response.data.status) {
    //       self.$toastr.success('処理成功', 'Success')
    //       detail.quantity = response.data.quantity
    //     } else {
    //       self.$toastr.error(response.data.message, '処理失敗')
    //       detail.quantity = response.data.old_quantity
    //     }
    //   }).finally(function () {
    //     self.isLoading = false
    //   })
    // },
    onChangeRemarks (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        remarks: detail.remarks
      }
      const self = this
      this.$http.post(this.$api_url.return_change_remarks, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_update_abstract_success'), this.translations('common.success'))
          detail.remarks = response.data.remarks
        } else {
          self.$toastr.error(response.data.message, this.translations('return.processing_failed'))
          detail.remarks = response.data.old_remarks
        }
        location.reload()
      }).finally(function () {
        self.isLoading = false
      })
    },
    clickIsProcessed () {
      this.isLoading = true
      const params = {
        return_id: this.returnId,
        is_processed: Number(this.returnInfo.is_processed) === 0 ? 1 : 0
      }
      const self = this
      this.$http.post(this.$api_url.return_update_is_processed, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return.notice_processing_status_success'), this.translations('common.success'))
          self.getReturnDetails()
          self.getAllReturnDetail()
        } else {
          self.$toastr.error(response.data.message, this.translations('return.processing_failed'))
          self.returnInfo.is_processed = response.data.old_is_processed
          self.originalInfo.is_processed = response.data.old_is_processed
        }
      }).finally(function () {
        self.isLoading = false
      })
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { clients_id: this.tempInfo.bill_to_id ? this.tempInfo.bill_to_id.id : '' }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewReturn:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SingleReturn:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },

    toUnitPriceTaxLabel (data) {
      const taxIncluded = data.tax_included || this.taxIncluded
      if (taxIncluded) {
        return Number(data.unit_price).toLocaleString()
      } else {
        return Number(data.unit_price_inctax).toLocaleString()
      }
    },

    onChangePrice (key, detail) {
      const taxRate = Number(detail.tax_rate || this.taxRate)
      detail[key] = detail[key].replace(/[^0-9]/g, '')
      if (key === 'unit_price') {
        detail.unit_price_inctax = this.$util.getIncludeTax(detail[key], taxRate)
      } else if (key === 'unit_price_inctax') {
        detail.unit_price = this.$util.getExcludeTax(detail[key], taxRate)
      }
    },
    setPrintDisable () {
      let indexDetail = _.findIndex(this.returnDetails, function (o) { return o.print === true })
      if (indexDetail === -1) {
        this.isPrintDisable = true
      } else {
        this.isPrintDisable = false
      }
    },
    setStatusDisable () {
      let indexDetail = _.findIndex(this.returnDetails, function (o) { return o.status === true })
      if (indexDetail === -1) {
        this.isStatusDisable = true
      } else {
        this.isStatusDisable = false
      }
    },
    async printRediect () {
      const eachPrintData = []
      for (let index = 0; index < this.returnDetails.length; index++) {
        const element = this.returnDetails[index]
        if (element.print && element.set_status !== 2) {
          eachPrintData.push(element['id'])
        }
      }
      let param = eachPrintData

      axios(this.$api_url.return_detail_pdf, {
        method: 'POST',
        responseType: 'blob',
        withCredentials: true,
        data: { param }
      })
        .then(response => {
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' })
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file)
          // Open the URL on new Window
          window.open(fileURL)
        })
        .catch(error => {
          console.log(error)
        })
    },
    onChangePrintAll (e) {
      let returnDetails = [...this.returnDetails]
      let indexDetail = _.findIndex(this.returnDetails, function (o) { return o.print === false })
      let setChildCheckBox = true
      if (indexDetail === -1) {
        setChildCheckBox = false
      }
      returnDetails = returnDetails.map(function (elem) {
        elem.print = setChildCheckBox
        return elem
      })
      this.returnDetails = returnDetails
      this.printAllChecked = e.target.checked
      this.setPrintDisable()
    },
    onChangeInputsPrint (e) {
      let id = parseInt(e.target.value)
      let indexDetail = _.findIndex(this.returnDetails, function (o) { return o.id === id })
      let returnDetails = [...this.returnDetails]
      returnDetails[indexDetail].print = !returnDetails[indexDetail].print
      this.returnDetails = returnDetails
      let checkAllPrintStatus = _.every(returnDetails, function (o) { return o.print === true })
      this.printAllChecked = checkAllPrintStatus
      this.setPrintDisable()
    },
    onChangeInputAll (e) {
      let returnDetails = [...this.returnDetails]
      let indexDetail = _.findIndex(this.returnDetails, function (o) { return o.status === false })
      let setChildCheckBox = true
      if (indexDetail === -1) {
        setChildCheckBox = false
      }
      returnDetails = returnDetails.map(function (elem) {
        elem.status = setChildCheckBox
        return elem
      })
      this.returnDetails = returnDetails
      this.inputAllChecked = e.target.checked
      if (this.inputAllChecked === true) {
        returnDetails.forEach(v => {
          this.changeIds.push(v.id)
        })
      }
      this.setStatusDisable()
    },
    onChangeInputs (e) {
      let id = parseInt(e.target.value)
      let indexDetail = _.findIndex(this.returnDetails, function (o) { return o.id === id })
      let returnDetails = [...this.returnDetails]
      returnDetails[indexDetail].status = !returnDetails[indexDetail].status
      this.returnDetails = returnDetails
      let checkAllInputStatus = _.every(returnDetails, function (o) { return o.status === true })
      this.inputAllChecked = checkAllInputStatus
      this.changeIds = Array.prototype.slice.call(document.querySelectorAll('input[name=change-status]:checked')).map(target => {
        return target.value
      })
      this.setStatusDisable()
    },
    async updateStatusMulti () {
      let isMoved = false
      this.changeIds.forEach(id => {
        const detail = this.returnDetails.find(d => d.id === Number(id))
        // 在庫が移動済のステータスになっている明細の「ステータス」を変更しようとした場合
        if (Number(detail.is_moved) === 1) {
          isMoved = true
        }
      })

      if (isMoved) {
        const result = await new Promise((resolve, reject) => {
          this.$dialog.confirm(this.translations('return.notice_move_return_delete')).then(() => {
            resolve({ data: true })
          }, () => {
            resolve({ data: false })
          })
        })
        if (!result.data) {
          return
        }
      }

      this.isLoading = true
      const params = {
        return_detail_ids: this.changeIds,
        return_status_id: this.changeStatusId,
        return_id: this.returnId
      }

      this.$http.post(this.$api_url.return_change_status_multi, params).then(response => {
        const result = response.data
        if (result.status) {
          result.list.forEach(data => {
            const detail = this.returnDetails.find(d => d.id === Number(data.detail_id))
            if (detail) {
              detail.return_status_id = Number(data.return_status_id)
              detail.is_moved = Number(data.is_moved)
            }
          })
          this.isConfirmReturn = false
          this.$toastr.success(this.translations('return.notice_status_updated'), this.translations('common.success'))
        } else {
          this.$toastr.error(result.message, this.translations('return.process_fail'))
          result.list.forEach(data => {
            const detail = this.returnDetails.find(d => d.id === Number(data.detail_id))
            if (detail) {
              detail.return_status_id = data.old_id
            }
          })
        }
      }).finally(() => {
        this.isLoading = false
        window.location.reload()
      })
    }
  }
}
</script>

<style>
#set-item-list{
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
.is_processed {
  vertical-align: middle !important;
}
[for='checkallPrint'] {
  margin-bottom: 0;
  margin-left: 0.6rem;
}
[for='checkallStatus'] {
  margin-bottom: 0;
}
[for='checkStatus'] {
  margin-top: 7px;
  margin-right: 0.6rem;
}
</style>

<style scoped>
.input-date {
  width: 140px;
}
.upload-file-evident {
  /*display: flex;*/
}
.show_status {
  margin-left:5px;
  color:red;
}
.list-status {
  width: 160px;
  display: flex;
  margin-bottom: 5px;
}
.admin-name {
  width: 60%;
}
.popover-x.right > .arrow.status {
  left: -15px;
}
.popover-body.status {
  padding: 20px;
}
.close.status {
    position: absolute;
    top: 0;
    right: 3px;
}
.text-status {
  color: #106710;
}
.isShowButtonApproved {
  position: absolute;
  top: 0;
  right: 0;
}
.form-line-po {
  position: relative;
}
.statusAllChecked{
  width: 0;
}
</style>
